import React, { useEffect, useState } from 'react';
import Router from 'next/router';
import withGA from 'next-ga';
import api from '../src/services/api';
import { Container } from '../src/pages/Home/styles';
import { Menu } from '../src/components/Menu';
import HeadPage from './../src/components/HeadPage';
import { NewBanner } from './../src/components/NewBanner';
import { AboutCompany } from './../src/components/AboutCompany';
import { SocialMedia } from './../src/components/SocialMedia';
import { SendCurriculum } from './../src/components/SendCurriculum';
import { Benefits } from './../src/components/Benefits';
import { Values } from './../src/components/Values';
import { Video } from './../src/components/Video';
import { Testimony } from './../src/components/Testimony';
import { NewFooter } from './../src/components/NewFooter';
import { InfoContact } from './../src/components/InfoContact';
import Search from './../src/components/Search';
import NewListVacancies from './../src/components/NewListVacancies';
import {
  optionsModel,
  optionsRegime,
  optionsUfs,
} from '../src/components/Search/options';

function Home({ retorno }) {
  const { params, data, options, query } = retorno;
  const { company, about, banner } = data;
  const [activedTestimony, setActivedTestimony] = useState(false);
  const [search, setSearch] = useState(query?.search || '');
  const [departmentSelected, setDepartmentSelected] = useState(
    query?.department
      ? options.find(o => o.value === query.department)
      : undefined
  );
  const [locationSelected, setLocationSelected] = useState(
    query?.location
      ? optionsUfs.find(o => o.value === query.location)
      : undefined
  );
  const [regimeSelected, setRegimeSelected] = useState(
    query?.regime
      ? optionsRegime.find(o => o.value === query.regime)
      : undefined
  );
  const [modelSelected, setModelSelected] = useState(
    query?.model ? optionsModel.find(o => o.value === query.model) : undefined
  );

  return (
    <Container>
      <HeadPage company={company} />
      <Menu
        company={company}
        params={params}
        setActivedTestimony={setActivedTestimony}
        retorno={retorno}
      />
      <NewBanner company={company} params={params} banner={banner} />
      <Search
        searchState={[search, setSearch]}
        optionsDepartments={options}
        departmentSelectedState={[departmentSelected, setDepartmentSelected]}
        locationSelectedState={[locationSelected, setLocationSelected]}
        regimeSelectedState={[regimeSelected, setRegimeSelected]}
        modelSelectedState={[modelSelected, setModelSelected]}
      />
      <NewListVacancies
        query={query}
        params={params}
        company={company}
        search={search}
        departmentSelected={departmentSelected}
        locationSelected={locationSelected}
        regimeSelected={regimeSelected}
        modelSelected={modelSelected}
      />
      <SendCurriculum primaryColor={company?.base_hexcolor} params={params} />
      <AboutCompany
        primaryColor={company?.base_hexcolor}
        about={about}
        query={query}
        company={company}
      />
      <InfoContact query={query} />
      <SocialMedia query={query} company={company} />
      <Benefits primaryColor={company?.base_hexcolor} query={query} />
      <Values query={query} />
      <Video query={query} primaryColor={company?.base_hexcolor} />
      <Testimony
        query={query}
        params={params}
        actived={activedTestimony}
        primaryColor={company?.base_hexcolor}
      />
      {activedTestimony && (
        <SendCurriculum primaryColor={company?.base_hexcolor} params={params} />
      )}
      <NewFooter />
    </Container>
  );
}
Home.getInitialProps = async ({ query, res }) => {
  try {
    if (query.label && query.label !== 'favicon.ico') {
      let fullpath = query.label;
      if (query.page_label) {
        fullpath = `${query.label}/${query.page_label}`;
      }
      await api.post('pages/redirect', { path: fullpath }).then(response => {
        if (response.data.url !== null) {
          if (typeof window !== 'undefined') {
            window.location.href = response.data.url;
          } else {
            res.writeHead(302, { Location: response.data.url });
            res.end();
            return;
          }
        }
      });
    }
  } catch (error) {
    //sem redirecionamentos
  }

  try {
    const { data } = await api.get(`career-page/${query.label}`);

    // Função helper para fazer requisições de forma segura
    const safeApiRequest = async (url, fallback = null) => {
      try {
        const response = await api.get(url);
        return response;
      } catch (error) {
        console.error(`Failed to fetch ${url}:`, error.message);
        // Log apenas em desenvolvimento
        if (process.env.NODE_ENV === 'development') {
          console.error('Error details:', error);
        }
        return fallback;
      }
    };

    const configurationUrl =
      query?.label && query?.page_label
        ? `pages/sections/configuration/get/${query.label}/${query.page_label}`
        : `pages/sections/configuration/get/${query.label}`;

    const responseConfiguration = await safeApiRequest(configurationUrl);

    const bannerUrl =
      query?.label && query?.page_label
        ? `pages/sections/banner/get/${query.label}/${query.page_label}`
        : `pages/sections/banner/get/${query.label}`;

    const responseBanner = await safeApiRequest(bannerUrl);

    const aboutUrl =
      query?.label && query?.page_label
        ? `pages/sections/about/get/${query.label}/${query.page_label}`
        : `pages/sections/about/get/${query.label}`;

    const responseAbout = await safeApiRequest(aboutUrl);

    const { company, departments } = data || {};

    const options = (departments || [])
      .filter(d => d && d.name !== 'Sem departamento')
      .map(d => ({
        label: d.name,
        value: d.name,
      }));

    const alls = options.concat({
      label: 'Todos',
      value: null,
    });

    // Acesso seguro às propriedades com fallbacks
    const base_hexcolor = responseConfiguration?.data?.data?.hexcolor || company?.base_hexcolor || '#0052CC';

    const logo_filename = responseConfiguration?.data?.data?.logo?.filename || company?.logo_filename;
    const logo_url = responseConfiguration?.data?.data?.logo?.url || company?.logo_url;

    const favicon_filename = responseConfiguration?.data?.data?.favicon?.filename || company?.favicon_filename;
    const favicon_url = responseConfiguration?.data?.data?.favicon?.url || company?.favicon_url;

    // Validação da cor hex
    let validatedHexColor = base_hexcolor;
    if (validatedHexColor && !/^#[0-9A-F]{6}$/i.test(validatedHexColor)) {
      validatedHexColor = '#0052CC';
    }

    const retorno = {
      query,
      params: data?.company?.label,
      options: alls,
      logo_url: logo_url,
      favicon_filename: favicon_filename,
      currentLabel:
        query?.label && query?.page_label
          ? `${query.label}/${query.page_label}`
          : query.label,
      data: {
        ...data,
        company: {
          ...data?.company,
          base_hexcolor: validatedHexColor,
          logo_filename,
          logo_url,
          favicon_filename,
          favicon_url,
        },
        about: responseAbout?.data?.data,
        banner: responseBanner?.data?.data,
      },
      error: false,
    };

    return { retorno };
  } catch (err) {
    // Log do erro principal apenas em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      console.error('Error in Home.getInitialProps:', err);
    }
    
    const retorno = {
      params: '',
      options: [],
      data: {},
      error: true,
    };

    return { retorno };
  }
};

export default withGA('UA-143354369-8', Router)(Home);
